<form [formGroup]="formGroup">
  <mat-select
    formControlName="templateEntityType"
    placeholder="Select entity type"
  >
    @for (option of entityTypeOptions; track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</form>
